import React, { useEffect } from 'react';
import { nanoid } from 'nanoid';

import ContactUs from './ContactUs';
import LanguageSelector from '../language-selector/LanguageSelector';
import { IMenu } from '../../interfaces/menu.interface';
import { IPageContext } from '../../interfaces/pagecontext.interface';
import LinkTo from '../link/Link';

interface Props {
  menu: IMenu[];
  pageContext: IPageContext;
  headerDesktopMenuClass?: string;
}

const DesktopMenu = ({ menu, pageContext, headerDesktopMenuClass = '' }: Props) => {
  const [openedIndex, setOpenedIndex] = React.useState(-1);
  const [openedMenu, setOpenedMenu] = React.useState(false);
  let setHoverTimeout: ReturnType<typeof setTimeout>;

  function closeMenu() {
    setOpenedIndex(-1);
    setOpenedMenu(!openedMenu);
    clearTimeout(setHoverTimeout);
  }

  if (typeof window !== 'undefined') {
    window.onresize = function () {
      if (window.innerWidth < 1024 && openedMenu) {
        closeMenu();
      }
    };
  }

  useEffect(() => {
    if ('ontouchstart' in document.documentElement) {
      document.body.classList.add('touch-device');
    }
  }, [openedIndex]);

  return (
    <div className={`main-navigation-desktop-view ${headerDesktopMenuClass}`}>
      <nav className="main-navigation">
        {Array.from(menu)
          .slice(0, menu.length - 1)
          .map((key: any) => {
            return (
              <div
                key={nanoid()}
                className="main-navigation-item no-children"
                onMouseLeave={() => clearTimeout(setHoverTimeout)}
                onClick={() => closeMenu()}
              >
                <LinkTo to={key.Link} pageContext={pageContext} className="main-navigation-link">
                  {key.Text}
                </LinkTo>
              </div>
            );
          })}

        {/* {pageContext.localeObjects.length > 1 && (
          <LanguageSelector className="main-navigation-item navigation-language" pageContext={pageContext} />
        )} */}

        <ContactUs buttonData={menu[menu.length - 1]} pageContext={pageContext} />
      </nav>
    </div>
  );
};

export default DesktopMenu;
